<template>
  <LinkToSelector
    v-model="selection"
    :query="query"
    :buildingId="buildingId"
    :buildings="buildings"
    :disabledItems="disabledItems"
    :allowedTypes="['space']"
    @clear:search="$emit('clear:query')"
  />
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { flatMapDeep } from "lodash";
import { LinkToSelector } from "@/SharedComponents/LinkToSelector";
import { useSites } from "@/Composables/useSites";

// Define Emits
const emit = defineEmits(["change", "submit", "clear:query"]);

// Sites
const { isLoading, data } = useSites();

const props = defineProps({
  initialState: { type: String, required: false },
  buildingId: { type: String, required: true },
  query: { type: String, required: false },
  disabledItems: { type: Array, default: () => [] },
});

const selection = ref({
  buildings: [props.buildingId],
  children: props.initialState ? [props.initialState] : [],
});

const isDirty = computed(() => {
  return props.initialState !== selection.value.children[0];
});

// Computed Props
const buildings = computed(() => {
  if (isLoading.value) {
    return [];
  }
  return data.value;
});

const space = computed(() =>
  flatMapDeep(
    buildings.value.find((building) => building.id === props.buildingId)
      .children
  ).find((item) => item.id === selection.value.children[0])
);

watch(space, () => {
  emit("change", space.value);
});

function submit() {
  if (!isDirty.value) {
    return;
  }

  emit("submit", space.value);
}

defineExpose({
  isDirty,
  submit,
});
</script>
